import { render } from "./SmilesInput.vue?vue&type=template&id=56e88e8a&scoped=true"
import script from "./SmilesInput.vue?vue&type=script&lang=js"
export * from "./SmilesInput.vue?vue&type=script&lang=js"

import "./SmilesInput.vue?vue&type=style&index=0&id=56e88e8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e88e8a"]])

export default __exports__